import React from "react";
import Button from "../../../../Button";

const MoviecardCardDetail = () => {
    return <>
        {/* <Button primary to="/" className="mb-2">
            Recargar Saldo
        </Button> */}
        <Button block to="/usuario/wallet/comprar/moviecard" className="mb-5">
            Comprar otra MovieCard
        </Button>
    </>;
};

export default MoviecardCardDetail;
